import { Component, inject, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Router, RouterLink } from '@angular/router';
import { TableModule } from 'primeng/table';
import { User } from 'src/app/user/model/user';
import { UserService } from '../../services/user.service';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { SelectModule } from 'primeng/select';
import { IftaLabelModule } from 'primeng/iftalabel';

@Component({
  selector: 'app-manage-users',
  imports: [
    ButtonModule,
    RouterLink,
    TableModule,
    ToastModule,
    ConfirmDialogModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    FormsModule,
    TooltipModule,
    SelectModule,
    IftaLabelModule,
  ],
  providers: [ConfirmationService],
  templateUrl: './manage-users.component.html',
})
export class ManageUsersComponent implements OnInit {
  userService = inject(UserService);
  userList: User[] = [];
  router = inject(Router);
  confirmationService = inject(ConfirmationService);
  notificationService = inject(NotificationService);
  ngOnInit(): void {
    this.getUsers();
  }
  globalFilter: string = '';
  roleFilter: string | null = null;

  roleOptions = [
    { label: 'All Roles', value: null },
    { label: 'Super Admin', value: 'superAdmin' },
    { label: 'Admin', value: 'admin' },
    { label: 'User', value: 'user' },
  ];

  get filteredUsers(): User[] {
    if (!this.roleFilter) {
      return this.userList;
    }
    return this.userList.filter((user) => user.role === this.roleFilter);
  }

  resetFilters(): void {
    this.globalFilter = '';
    this.roleFilter = null;
  }

  getUsers() {
    this.userService.allUsers.subscribe({
      next: (users) => {
        this.userList = users;
      },
      error: (err) => {
        console.error('Error fetching users:', err);
      },
    });
  }
  editUser(userId: string) {
    this.router.navigate(['/admin/user/edit', userId]);
  }
  confirmDelete(userId: string) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this user?',
      header: 'delete confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.deleteUser(userId),
    });
  }

  deleteUser(userId: string) {
    this.userService.delete(userId).subscribe({
      next: (response) => {
        this.userList = this.userList.filter((user) => user.id !== response.id);
        this.notificationService.success('user successfully deleted');
      },
      error: (err) => {
        console.error('Error deleting user:', err),
          this.notificationService.error('error while deleting user');
      },
    });
  }

  getUserName(user: User): string {
    if (!user.firstName && !user.lastName) {
      return '--';
    }
    return `${user.firstName} ${user.lastName}`;
  }
  formatDate(inputDate: Date): string {
    if (!inputDate) {
      return '--';
    }
    const date = new Date(inputDate);
    const formatted = date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Europe/Paris',
    });
    return formatted.replace(',', '');
  }
}
